import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useState } from 'react'

import { DateSpecificFields } from './date_specific_fields'
import { DateSpecificHeader } from './date_specific_header'
import { DateSpecificFieldsReadOnly } from './date_specific_rules_read_only'
import { DateSpecificSection } from './date_specific_section'

export const DateSpecificRulesReadOnly = ({
  compact = false,
  ...props
}) => {
  const isPhone = useDeviceType('isPhone')

  return (
    <>
      <DateSpecificHeader compact={isPhone || compact} readOnly />
      <DateSpecificFieldsReadOnly {...props} />
    </>
  )
}

const DateSpecificRulesFields = ({
  alwaysDisplayTitle = false,
  redesignStyling = false,
  compact = false,
  trackOpen,
  ...props
}) => {
  const isPhone = useDeviceType('isPhone')
  const isTabletDown = useDeviceType('isTabletDown')
  const [editingDates, setEditingDates] = useState(null)

  const handleAdd = () => {
    if (trackOpen && !editingDates) trackOpen()
    setEditingDates([])
  }

  if (redesignStyling) {
    return (
      <>
        <DateSpecificHeader handleAdd={handleAdd} compact={isPhone || compact} />
        <DateSpecificFields
          editingDates={editingDates}
          setEditingDates={setEditingDates}
          {...props}
        />
      </>
    )
  }

  return (
    <DateSpecificSection
      displayTitle={!isTabletDown || alwaysDisplayTitle}
      editingDates={editingDates}
      setEditingDates={setEditingDates}
      {...props}
    />
  )
}

export const DateSpecificRules = ({ readOnly, ...props }) => (
  !readOnly
    ? <DateSpecificRulesFields {...props} />
    : <DateSpecificRulesReadOnly {...props} />
)
